// extracted by mini-css-extract-plugin
module.exports = {"container":"e_4m","sizeMedium":"e_5m","sizeSmall":"e_6m","icon":"e_7m"};